module.exports = function ($stateProvider) {
    $stateProvider
        // My Account
        .state('shop.myaccount', {
            url: '/my-account',
            parent: 'root',
            resolve: {
                deps: ['$$animateJs', '$ocLazyLoad', function ($$animateJs, $ocLazyLoad) {
                    return $ocLazyLoad.load(window.wowModules[4].files[0]);
                }]
            },
            views: {
                'center-panel@': {
                    template: '<wow-my-account></wow-my-account>'
                }
            },
            data: {
                analytics: 'bws:web:my account',
                authenticate: true,
                pageMetadata: {
                    title: 'Account Details',
                    metaDescription: 'Account Details'
                },
                richer_relevance: {
                   type: 'MY_PROFILE_PAGE'
                },
                openOrderTracker: true
            }
        })
        .state('shop.myaccount.reviews', {
            url: '/reviews',
            data: {
               analytics: 'bws:web:my account: reviews'
            },
            views: {
                'center-panel@': {
                    template: '<wow-review-overview view-mode="all">' +
                                  '<wow-standard-heading title="My Reviews"></wow-standard-heading>' +
                               '</wow-review-overview>'
                }
            }
        })
        .state('shop.myaccount.orderhistory', {
            url: '/order-history?tab&orderId&pageNumber',
            views: {
                'center-panel@': {
                    template: '<wow-order-history></wow-order-history>'
                }
            },
            data: {
                analytics: 'bws:web:my account:order history',
                disableOrderTracker: true,
                authenticate: true,
                pageMetadata: {
                    title: 'Order History',
                    metaDescription: 'Order History'
                }
            }
        })
        .state('shop.myaccount.myprofile', {
            url: '/my-profile',
            views: {
                'center-panel@': {
                    template: '<bws-edit-profile></bws-edit-profile>'
                }
            },
            data: {
                analytics: 'bws:web:my account:my profile',
                authenticate: true,
                pageMetadata: {
                    title: 'Edit your profile',
                    metaDescription: 'Edit your profile'
                }
            }
        })
        .state('shop.myaccount.verification', {
            url: '/idverified?guid',
            views: {
                'center-panel@': {
                    template: '<wow-proactive-verification-redirect></wow-proactive-verification-redirect>'
                }
            },
            data: {               
                authenticate: true,
            }
        });
};



/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/configuration/routes/myaccount.js
 **/